<template>
  <div class="big_box4">
    <div class="top_title3">
      <h4>{{title}}</h4>
      <div class="bottom_font clearfix">
        <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
        <h6 class="center">税款所属期：<span>{{durationOfTaxTime}}</span></h6>
        <h6 class="right">
          <p>单位：元</p>
          <p>纳税人识别号：<span>{{taxNo}}</span></p>
        </h6>
      </div>
    </div>
    <table class="content" cellspacing="0" width="100%"  v-for="item in hzList" :key="item">
      <tr class="top_bg">
        <td class="center" style="width:4%">编号</td>
        <td colspan="2" class="center" style="width:32%">核定方法</td>
        <td class="center" style="width:32%">当期允许抵扣农产品增值税进项税额（元）</td>
        <td class="center" style="width:32%">备注</td>
      </tr>
      
      <tr>
        <td class="center" rowspan="2">1</td>
        <td class="center" rowspan="2">以购进农产品为原料生产货物</td>
        <td class="center">投入产出法</td>
        <qzf-str-td type="text" v-model:amount="item.trccf" @change="changeList()"></qzf-str-td>
        <td><input type="text" v-model="item.trccfRemark"></td>
      </tr>
      <tr>
        <td class="center">成本法</td>
        <qzf-str-td type="text" v-model:amount="item.cbf" @change="changeList()"></qzf-str-td>
        <td><input type="text" v-model="item.cbfRemark"></td>
      </tr>
      <tr>
        <td class="center">2</td>
        <td class="center" colspan="2">购进农产品直接销售</td>
        <qzf-str-td type="text" v-model:amount="item.gjncpzjxs" @change="changeList()"></qzf-str-td>
        <td><input type="text" v-model="item.gjncpzjxsRemark"></td>
      </tr>
      <tr>
        <td class="center">3</td>
        <td class="center" colspan="2">购进农产品用于生产经营且不构成货物实体</td>
        <qzf-str-td type="text" v-model:amount="item.gjncpyysc" @change="changeList()"></qzf-str-td>
        <td><input type="text" v-model="item.gjncpyyscRemark"></td>
      </tr>
      <tr>
        <td class="center" colspan="3">合计</td>
        <td class="right" style="  line-height: 34px;padding-right:17px;font-size: 14px;color: #333;">{{sumAmount}}</td>
        <td></td>
      </tr>
    </table>
  </div>
  <div class="save_box">
    <el-button @click="saveFb9" type="primary" size="mini" plain>保存</el-button>
  </div>
</template>

<script>
import { gsInfo , gsEdit} from '@/api/taxCalculation.js'
export default {
  name: 'deduct',
  props: {
    title:String,
    comId:{
      default:0,
      type:Number
    },
  },
  computed: {
    //金额合计
    sumAmount() {
      let count = 0;
      this.hzList.map(v => {
        count = Number(v.trccf*1 + v.cbf*1 + v.gjncpzjxs*1 + v.gjncpyysc*1)
      });
      return Number(count.toFixed(2));
    },
  },
  data() {
    return {
      contentStyleObj:{}, //高度变化
      comName:this.$store.getters['user/comInfo'].comName,
      durationOfTaxTime:'',
      taxNo:this.$store.getters['user/comInfo'].taxNo,
      hzList:[{cbf: "",cbfRemark: "",gjncpyysc: "",gjncpyyscRemark: "",gjncpzjxs: "",gjncpzjxsRemark: "",trccf: "",trccfRemark: ""}],
    }
  },
  created() {
    // 获取窗口高度
    this.contentStyleObj=this.$getHeight(400)
  },
  methods: {
    changeList(){

    },
    getList(){
      gsInfo({tableName: 'gs_vat',itemName:'fb9'}).then(res=>{
        if(res.data.data.info){
          this.hzList = res.data.data.info
          this.durationOfTaxTime = res.data.data.time
        }
      })
    },
    saveFb9(){
      let param = {
        tableName:'gs_vat',
        itemName:'fb9',
        items:this.hzList
      }
      gsEdit(param).then(res=>{
        if(res.data.msg == "success"){
          this.$qzfMessage("保存成功")
          this.getList()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.big_box4{
  // width: 98%;
  padding: 0 15px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  .add {
    width: 1.4em;
    height: 1.4em;
    vertical-align: -0.15em;
    fill: currentColor;
    position: absolute;
    left: 12px;
    top: 175px;
    font-size: 16px;
    color: #f15a24;
    cursor: pointer;
    .svg-icon {
      width: 100%;
      height: 100%;
      vertical-align: -0.15em;
      fill: currentColor;
      overflow: hidden;
    }
  }
}
.content{
  // width: 2000px;
  width: 98%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 25px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
  input{
    width: 100%;
    line-height: 28px;
    padding: 0 3px;
    font-size: 14px;
    text-align: right;
  }
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h4{
    font-size: 20px;
    color: #333;
    font-weight: 600;
    text-align: center;
  }
  h5{
    font-size: 16px;
    color: #333;
    font-weight: normal;
    text-align: center;
    margin-top: 10px;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    padding: 0 16px;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
    .right {
      text-align: right;
    }
    .center {
      text-align: center;
    }
  }
}
.center{
  text-align: center;
}
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
</style>